export const getNextDate = (dateToAdd = 1) => {
  const date = new Date();
  date.setDate(date.getDate() + dateToAdd);
  return date;
};
